import * as React from "react";
const SvgFiRrMace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mace_svg__a)">
      <path
        fill="#062147"
        d="M21.484 11.036q.245-.577.378-1.205l1.882-.88a.527.527 0 0 0 0-.904l-1.882-.88a6.5 6.5 0 0 0-.64-1.748L23.95.623a.426.426 0 0 0-.574-.574L18.58 2.777a6.5 6.5 0 0 0-1.749-.64L15.952.255a.527.527 0 0 0-.905 0l-.879 1.882q-.627.131-1.203.377L8.658.05a.426.426 0 0 0-.574.574l2.234 3.969A6.5 6.5 0 0 0 9.14 7.169l-1.882.879a.527.527 0 0 0 0 .905l1.882.879a6.5 6.5 0 0 0 1.12 2.496L.293 22.294a.999.999 0 1 0 1.414 1.413l9.965-9.964a6.5 6.5 0 0 0 2.497 1.12l.88 1.882c.204.341.7.341.904 0l.88-1.883a6.5 6.5 0 0 0 2.572-1.177l3.972 2.245a.426.426 0 0 0 .574-.575l-2.466-4.318M11 8.5C11 6.019 13.02 4 15.5 4S20 6.019 20 8.5 17.981 13 15.5 13A4.505 4.505 0 0 1 11 8.5m4.5 1.5a1.5 1.5 0 1 1 .001-3.002 1.5 1.5 0 0 1 0 3.002"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mace_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMace;
